import { render, staticRenderFns } from "./GameStageComponent.vue?vue&type=template&id=2c6eac4b&"
import script from "./GameStageComponent.vue?vue&type=script&lang=ts&"
export * from "./GameStageComponent.vue?vue&type=script&lang=ts&"
import style0 from "./GameStageComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports